import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { ActivityParentEntityId, PhoneNumberE164 } from "@sp-crm/core";
import { PhoneCallButton } from "components/telecom/phone-call-button";
import { PhoneSmsButton } from "components/telecom/phone-sms-button";
import { InlinePhoneField, InlineTextField } from "components/ui/inline-field";
import { defaultLinkColour } from "components/ui/link";
import React from "react";
import { sanitizeUri } from "util/uri";

interface HeaderPhoneFieldProps {
    label: React.ReactNode;
    initial: PhoneNumberE164 | null;
    onCommit: (newValue: PhoneNumberE164) => void;
    entityId: ActivityParentEntityId;
}

export const HeaderPhoneField: React.FC<HeaderPhoneFieldProps> = props => {
    const { label, initial, onCommit, entityId } = props;

    return (
        <div className="flex items-end gap-2">
            <div className="min-w-0 flex-1">
                <InlinePhoneField label={label} initial={initial} onCommit={onCommit} />
            </div>
            {initial ? (
                <div className="mb-1 flex flex-none items-center gap-2">
                    <PhoneCallButton value={initial} entityId={entityId} />
                    <PhoneSmsButton value={initial} entityId={entityId} />
                </div>
            ) : null}
        </div>
    );
};

interface HeaderWebsiteFieldProps {
    initial: string;
    onCommit: (newValue: string) => void;
}

export const HeaderWebsiteField: React.FC<HeaderWebsiteFieldProps> = props => {
    const { initial, onCommit } = props;

    return (
        <div className="flex items-end gap-1">
            <div className="min-w-0 flex-1">
                <InlineTextField label="Website" initial={initial} onCommit={onCommit} />
            </div>
            {initial ? (
                <a
                    href={sanitizeUri(initial)}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Open website"
                    className={`mb-1 flex-none ${defaultLinkColour}`}>
                    <ArrowTopRightOnSquareIcon className="h-5 w-5" />
                </a>
            ) : null}
        </div>
    );
};
